import picturefill from 'picturefill';

picturefill();



// WEBPACK FOOTER //
// ./scripts/picturefill.js